/**
 * Fits the map viewport to the provided coordinate bounds.
 * Uses the frontend naming convention: minLatitude, minLongitude, maxLatitude, maxLongitude.
 *
 * @param {Object} google - The Google Maps API object.
 * @param {Object} map - The Google Maps Map instance.
 * @param {{ minLatitude: number, minLongitude: number, maxLatitude: number, maxLongitude: number }} bounds
 */
function fitBoundsOnMap(google, map, { minLatitude, minLongitude, maxLatitude, maxLongitude }) {
  if (!google || !map) {
    return;
  }

  const latLngBounds = new google.maps.LatLngBounds();
  latLngBounds.extend(new google.maps.LatLng(minLatitude, minLongitude));
  latLngBounds.extend(new google.maps.LatLng(maxLatitude, maxLongitude));
  map.fitBounds(latLngBounds);
}

export default fitBoundsOnMap;